import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    slantRatio: 0.15
};
/**
 * Represents a Data Input/Output shape, a flowchart element used to indicate
 * data input or output operations. Extends Rectangle with a parallelogram path.
 */
export class DataInputOutput extends Rectangle {
    /**
     * Creates a new DataInputOutput instance.
     * @param options - Configuration options for the data input/output shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the data input/output shape path as a parallelogram.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const { slantRatio, cornerRadius } = this.options;
        const slant = width * slantRatio;
        const points = [
            { x: slant, y: 0 },
            { x: width, y: 0 },
            { x: width - slant, y: height },
            { x: 0, y: height }
        ];
        drawRoundedPolygon(drawingElement, points, cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
